<template>
  <section class="viewsrhwxIntoCode_followCode">
    <div class="logo">
      <img src="../assets/img/logo.png" alt="" width="73%" />
    </div>
    <p class="tittle">请长按关注以下二维码</p>
    <div class="eqcode">
      <img :src="src" alt="" />
    </div>
  </section>
</template>

<script>
export default {
  props: [""],

  data() {
    return {
      src: ""
    };
  },

  computed: {},

  watch: {},

  components: {},

  mixins: [],

  beforeRouteEnter(to, from, next) {
    next();
  },

  beforeRouteUpdate(to, from, next) {
    next();
  },

  beforeRouteLeave(to, from, next) {
    next();
  },

  beforeCreate() {},

  created() {
    this.$common
      .http({
        url: "/api/queue/driver/pre_operate_info",
        data: {}
      })
      .then(res => {
        this.src = res.data.data.wxmp_code_url;
      });
  },

  beforeMount() {},

  mounted() {},

  beforeUpdate() {},

  updated() {},

  activated() {},

  deactivated() {},

  beforeDestroy() {},

  destroyed() {},

  errorCaptured() {},

  methods: {}
};
</script>
<style lang="less" scoped>
@import "../assets/css/common";
.viewsrhwxIntoCode_followCode {
  padding: 16px;
  .logo {
    text-align: center;
    padding: 33px 27px 39px;
  }
  .tittle {
    margin: 0;
    font-size: 16px;
    color: #666666;
    letter-spacing: 0;
    text-align: center;
    line-height: 20px;
    padding-bottom: 39px;
  }
  .eqcode {
    width: 100%;
    height: 260px;
    text-align: center;
    // padding: 10px;
    // box-sizing: border-box;
    // border: 1px solid #e4e4e4;
    // border-radius: 2px;
    img {
      width: 260px;
    }
  }
}
</style>
<style lang="less">
.viewsrhwxIntoCode_followCode {
}
</style>
